import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { logout } from '../slices/auth'

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  React.useEffect(()=> {
      dispatch(logout());
      navigate('/');
  }, [dispatch, navigate])
  return <></>;
}

export default Logout;